var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseru(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1129 10.6758H15.5662C15.7238 11.1074 15.81 11.5732 15.81 12.0588V17.9045C15.81 18.1069 15.7747 18.3012 15.7106 18.4819H18.2677C19.2229 18.4819 20 17.7048 20 16.7496V13.5629C20 11.9709 18.7048 10.6758 17.1129 10.6758Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19005 12.0588C4.19005 11.5732 4.27618 11.1074 4.43384 10.6758H2.88712C1.29516 10.6758 0 11.9709 0 13.5629V16.7497C0 17.7048 0.777072 18.4819 1.73227 18.4819H4.28938C4.22528 18.3011 4.19005 18.1069 4.19005 17.9045V12.0588Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7679 9.17188H8.23184C6.63989 9.17188 5.34473 10.467 5.34473 12.059V17.9047C5.34473 18.2236 5.60324 18.4821 5.92215 18.4821H14.0776C14.3965 18.4821 14.655 18.2236 14.655 17.9047V12.059C14.655 10.467 13.3598 9.17188 11.7679 9.17188Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 1.51562C8.08541 1.51562 6.52783 3.07321 6.52783 4.98778C6.52783 6.28642 7.24459 7.4206 8.30311 8.01607C8.80518 8.29849 9.38401 8.4599 9.99995 8.4599C10.6159 8.4599 11.1947 8.29849 11.6968 8.01607C12.7553 7.4206 13.4721 6.28638 13.4721 4.98778C13.4721 3.07325 11.9145 1.51562 9.99995 1.51562Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90308 4.75391C2.47124 4.75391 1.3064 5.91875 1.3064 7.35059C1.3064 8.78243 2.47124 9.94728 3.90308 9.94728C4.26629 9.94728 4.61215 9.87204 4.92633 9.73681C5.46953 9.50294 5.91742 9.08895 6.19457 8.5704C6.3891 8.20645 6.49977 7.79126 6.49977 7.35059C6.49977 5.91879 5.33492 4.75391 3.90308 4.75391Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0969 4.75391C14.6651 4.75391 13.5002 5.91875 13.5002 7.35059C13.5002 7.7913 13.6109 8.20649 13.8054 8.5704C14.0826 9.08899 14.5305 9.50298 15.0737 9.73681C15.3879 9.87204 15.7337 9.94728 16.0969 9.94728C17.5288 9.94728 18.6936 8.78243 18.6936 7.35059C18.6936 5.91875 17.5288 4.75391 16.0969 4.75391Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseru);
export default __webpack_public_path__ + "static/media/useru.f3abe393a6af2f123b17844353a2ad8a.svg";
export { ForwardRef as ReactComponent };